export default __webpack_public_path__ + "static/media/galleryimg1.01f6184a.jpg";